import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbkrehyr8s: FaireProductEntity = {
  token: "p_cbkrehyr8s",
  type: "product",
  name: "Banana Bread Chocolate Chip Protein Bar",
  brandName: "Aloha",
  imageUrl:
    "https://cdn.faire.com/fastly/b0d1dd88c0668a01383a100d995df737c074af74beb797143e0387eb0385a252.jpeg",
  priceDollars: 26.38,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/203ce9845ff5329de92fc9be60297729580d427658bbe805fb4c8ed7748be5d4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
